module.exports = __webpack_public_path__ + "img/Z86规格.0415dc1a.jpg";